<template>
  <AppLayout>
    <div class="transaction fleet-module-page">
      <section class="container">
        

        <div class="fleet-stat-grid">
          <div class="fleet-stat-card">
            <span>Total Vehicles</span>
            <strong>{{ vehicleStats?.total || 0 }}</strong>
          </div>
          <div class="fleet-stat-card">
            <span>Available</span>
            <strong>{{ vehicleStats?.available || 0 }}</strong>
          </div>
          <div class="fleet-stat-card">
            <span>Unavailable</span>
            <strong>{{ vehicleStats?.unavailable || 0 }}</strong>
          </div>
          <div class="fleet-stat-card">
            <span>Average Odometer</span>
            <strong>{{ formatNumber(vehicleStats?.avgOdometer || 0) }}</strong>
          </div>
        </div>

        <div class="filter-search">
          <div class="filter-search-content">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Search</label>
                  <input v-model="filters.search" class="form-control" placeholder="Plate, make, model..." />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Vehicle Type</label>
                  <select v-model="filters.typeId" class="form-control">
                    <option value="">All Types</option>
                    <option v-for="t in types" :key="t.id" :value="String(t.id)">{{ t.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Status</label>
                  <select v-model="filters.statusId" class="form-control">
                    <option value="">All Statuses</option>
                    <option v-for="s in statuses" :key="s.id" :value="String(s.id)">{{ s.name }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-toolbar">
            <div class="table-toolbar-actions">
              <button class="btn btn-style-2 btn-sm" @click="openCreateModal">Add Vehicle</button>
            </div>
          </div>
        <div class="data-table-wrapper">
          
          <div class="table-wrap">
            <table ref="fleetTable" class="fleet-table table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Plate</th>
                  <th>Make / Model</th>
                  <th>Type</th>
                  <th>Fuel</th>
                  <th>Status</th>
                  <th>Odometer</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, index) in filteredVehicles" :key="v.id || v.vehicle_id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ v.plateNumber || '-' }}</td>
                  <td>{{ [v.make, v.model].filter(Boolean).join(' ') || '-' }}</td>
                  <td class="capitalize" style="text-transform: capitalize !important;">{{ (v?.type?.name || '-').toLowerCase() }}</td>
                  <td class="capitalize" style="text-transform: capitalize !important;">{{ (v?.fuelType?.name || '-').toLowerCase() }}</td>
                  <td>
                    <span class="status-pill capitalize" :class="statusClass(v?.status?.name)">{{ (v?.status?.name || 'Unknown').toLowerCase() }}</span>
                  </td>
                  <td>{{ formatNumber(v.currentOdometer) }}</td>
                  <td>
                    <div class="table-actions">
                      <RouterLink class="mini-btn" :to="`/fleet/vehicles/${v.id || v.vehicle_id}`">View</RouterLink>
                      <button class="mini-btn" @click="startEdit(v)">Edit</button>
                      <button class="mini-btn danger" @click="removeVehicle(v)">Delete</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="showModal" class="svc-modal-overlay" @click.self="closeModal">
          <div class="svc-modal-box">
            <div class="svc-modal-header">
              <h6 class="fw-bold mb-0">{{ editId ? 'Edit Vehicle' : 'Add Vehicle' }}</h6>
              <button class="btn-close-plain" @click="closeModal">&times;</button>
            </div>
            <div class="svc-modal-body">
              <div class="row g-2">
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Plate Number</label>
                  <input v-model="form.plateNumber" class="form-control form-control-sm" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">VIN</label>
                  <input v-model="form.vin" class="form-control form-control-sm" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Make</label>
                  <input v-model="form.make" class="form-control form-control-sm" />
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Model</label>
                  <input v-model="form.model" class="form-control form-control-sm" />
                </div>
                <div class="col-md-4">
                  <label class="form-label" style="font-size:11px;">Year</label>
                  <input v-model.number="form.year" type="number" class="form-control form-control-sm" :min="1900" :max="CURRENT_YEAR + 1" />
                </div>
                <div class="col-md-4">
                  <label class="form-label" style="font-size:11px;">Current Odometer</label>
                  <input v-model.number="form.currentOdometer" type="number" class="form-control form-control-sm" min="0" />
                </div>
                <div class="col-md-4">
                  <label class="form-label" style="font-size:11px;">Vehicle Type</label>
                  <select v-model.number="form.type_id" class="form-control form-control-sm">
                    <option :value="null">Select type</option>
                    <option v-for="t in types" :key="t.id" :value="t.id">{{ t.name }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Fuel Type</label>
                  <select v-model.number="form.fuel_type_id" class="form-control form-control-sm">
                    <option :value="null">Select fuel</option>
                    <option v-for="t in fuelTypes" :key="t.id" :value="t.id">{{ t.name }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label" style="font-size:11px;">Status</label>
                  <select v-model.number="form.status_id" class="form-control form-control-sm">
                    <option :value="null">Select status</option>
                    <option v-for="s in statuses" :key="s.id" :value="s.id">{{ s.name }}</option>
                  </select>
                </div>
              </div>
              <p v-if="errorMessage" class="text-danger small mt-2">{{ errorMessage }}</p>
            </div>
            <div class="svc-modal-footer">
              <button class="btn btn-sm btn-style-2" @click="closeModal">Cancel</button>
              <button class="btn btn-sm btn-primary" @click="saveVehicle" :disabled="saving">
                <span v-if="saving"><i class="fas fa-spinner fa-spin me-1"></i>Saving...</span>
                <span v-else>{{ editId ? 'Update Vehicle' : 'Save Vehicle' }}</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '@/components/AppLayout.vue';
import fleetApi from '@/api/fleet';
import Swal from '@/utils/swal';
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import $ from 'jquery';
import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';

const CURRENT_YEAR = new Date().getFullYear();

function emptyForm() {
  return {
    plateNumber: '',
    vin: '',
    make: '',
    model: '',
    year: CURRENT_YEAR,
    type_id: null,
    fuel_type_id: null,
    currentOdometer: 0,
    status_id: null,
  };
}

export default {
  name: 'FleetVehicles',
  components: { AppLayout },
  data() {
    return {
      CURRENT_YEAR,
      vehicles: [],
      types: [],
      statuses: [],
      fuelTypes: [],
      dataTable: null,
      showModal: false,
      editId: null,
      saving: false,
      errorMessage: '',
      filters: {
        search: '',
        typeId: '',
        statusId: '',
      },
      form: emptyForm(),
    };
  },
  computed: {
    filteredVehicles() {
      const q = String(this.filters.search || '').toLowerCase().trim();
      return (this.vehicles || []).filter((v) => {
        const text = [v.plateNumber, v.make, v.model, v?.type?.name, v?.status?.name]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        const matchesSearch = !q || text.includes(q);
        const matchesType = !this.filters.typeId || String(v?.type?.id || v.type_id) === String(this.filters.typeId);
        const matchesStatus = !this.filters.statusId || String(v?.status?.id || v.status_id) === String(this.filters.statusId);
        return matchesSearch && matchesType && matchesStatus;
      });
    },
    vehicleStats() {
      const items = Array.isArray(this.vehicles) ? this.vehicles : [];
      const available = items.filter((v) => String(v?.status?.name || '').toUpperCase().includes('AVAILABLE')).length;
      const unavailable = items.length - available;
      const avgOdometer = items.length
        ? Math.round(items.reduce((sum, v) => sum + Number(v.currentOdometer || 0), 0) / items.length)
        : 0;
      return { total: items.length, available, unavailable, avgOdometer };
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.initializeDataTable();
      },
    },
  },
  methods: {
    destroyDataTable() {
      if (this.dataTable && typeof this.dataTable.destroy === 'function') {
        this.dataTable.destroy();
        this.dataTable = null;
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        const tableElement = this.$refs.fleetTable;
        if (!tableElement) return;
        this.destroyDataTable();
        this.dataTable = $(tableElement).DataTable({
          responsive: true,
          destroy: true,
          pageLength: 10,
          lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'All']],
          language: {
            emptyTable: 'No vehicles found',
            paginate: {
              previous: '<i class="fa fa-chevron-left"></i>',
              next: '<i class="fa fa-chevron-right"></i>',
            },
          },
          dom: 'Bfrtip',
          buttons: [
            'colvis',
            'pageLength',
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-sm btn-outline-primary',
              exportOptions: { columns: ':visible' },
            },
          ],
        });
      });
    },
    notifyError(err) {
      this.$toast?.error?.(err?.message || 'Request failed');
    },
    formatNumber(v) {
      if (v === null || v === undefined) return '-';
      return new Intl.NumberFormat().format(Number(v));
    },
    statusClass(status) {
      const value = String(status || '').toLowerCase();
      if (value.includes('available')) return 'status-active';
      if (value.includes('maintenance') || value.includes('unavailable') || value.includes('decommission')) return 'status-expired';
      return 'status-default';
    },
    buildVehiclePayload() {
      return {
        plateNumber: String(this.form.plateNumber || '').trim(),
        vin: String(this.form.vin || '').trim() || undefined,
        make: String(this.form.make || '').trim(),
        model: String(this.form.model || '').trim(),
        year: Number(this.form.year),
        type_id: Number(this.form.type_id),
        fuel_type_id: Number(this.form.fuel_type_id),
        currentOdometer: Number(this.form.currentOdometer ?? 0),
        status_id: Number(this.form.status_id),
      };
    },
    validate(payload) {
      if (!payload.plateNumber || !payload.make || !payload.model) {
        this.errorMessage = 'Plate number, make and model are required.';
        return false;
      }
      if (!payload.type_id || !payload.fuel_type_id || !payload.status_id) {
        this.errorMessage = 'Vehicle type, fuel type and status are required.';
        return false;
      }
      if (!Number.isInteger(payload.year) || payload.year < 1900 || payload.year > CURRENT_YEAR + 1) {
        this.errorMessage = `Year must be between 1900 and ${CURRENT_YEAR + 1}.`;
        return false;
      }
      this.errorMessage = '';
      return true;
    },
    async loadData() {
      try {
        const [vehiclesRes, typesRes, statusesRes, fuelTypesRes] = await Promise.all([
          fleetApi.listVehicles({ page: 1, limit: 200 }),
          fleetApi.listVehicleTypes(),
          fleetApi.listVehicleStatuses(),
          fleetApi.listFuelTypes(),
        ]);
        this.vehicles = fleetApi.unwrapList(vehiclesRes);
        this.types = fleetApi.unwrapList(typesRes);
        this.statuses = fleetApi.unwrapList(statusesRes);
        this.fuelTypes = fleetApi.unwrapList(fuelTypesRes);
        this.initializeDataTable();
      } catch (err) {
        this.notifyError(err);
      }
    },
    openCreateModal() {
      this.editId = null;
      this.form = emptyForm();
      this.errorMessage = '';
      this.showModal = true;
    },
    startEdit(v) {
      this.editId = v.id || v.vehicle_id;
      this.form = {
        plateNumber: v.plateNumber || '',
        vin: v.vin || '',
        make: v.make || '',
        model: v.model || '',
        year: v.year || CURRENT_YEAR,
        type_id: v.type_id || v?.type?.id || null,
        fuel_type_id: v.fuel_type_id || v?.fuelType?.id || null,
        currentOdometer: Number(v.currentOdometer || 0),
        status_id: v.status_id || v?.status?.id || null,
      };
      this.errorMessage = '';
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.editId = null;
      this.form = emptyForm();
      this.errorMessage = '';
    },
    async saveVehicle() {
      const payload = this.buildVehiclePayload();
      if (!this.validate(payload)) return;

      this.saving = true;
      try {
        if (this.editId) {
          await fleetApi.updateVehicle(this.editId, payload);
          this.$toast?.success?.('Vehicle updated');
        } else {
          await fleetApi.createVehicle(payload);
          this.$toast?.success?.('Vehicle created');
        }
        this.closeModal();
        await this.loadData();
      } catch (err) {
        this.notifyError(err);
      } finally {
        this.saving = false;
      }
    },
    async removeVehicle(v) {
      const id = v.id || v.vehicle_id;
      if (!id) return;
      const result = await Swal.fire({
        title: `Delete vehicle ${v.plateNumber}?`,
        text: 'This action cannot be undone!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      });
      if (!result.isConfirmed) return;
      try {
        await fleetApi.deleteVehicle(id);
        this.$toast?.success?.('Vehicle deleted');
        await this.loadData();
      } catch (err) {
        this.notifyError(err);
      }
    },
  },
  mounted() {
    this.loadData();
  },
  beforeUnmount() {
    this.destroyDataTable();
  },
};
</script>

<style scoped>
@import './fleet.shared.css';
</style>
